import { render, staticRenderFns } from "./DrugsMovementRep.vue?vue&type=template&id=f36088d2&"
import script from "./DrugsMovementRep.vue?vue&type=script&lang=js&"
export * from "./DrugsMovementRep.vue?vue&type=script&lang=js&"
import style0 from "./DrugsMovementRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports